module.exports = __webpack_public_path__ + "static/media/dryer.ea1c78f5.svg";